import FormattedMessage from 'I18n/components/FormattedMessage';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { jsx as _jsx } from "react/jsx-runtime";
const UnavailableBusinessUnitData = () => {
  return /*#__PURE__*/_jsx(UITooltip, {
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "dashboard.table.collectedForms.unavailableBusinessUnit"
    }),
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "notApplicable"
    })
  });
};
export default UnavailableBusinessUnitData;